import React from 'react';
import { Box, TableCell, TableRow, Skeleton } from '@mui/material';
import { ViewKey } from './WorkItemsView.constants';

interface WorkItemRowSkeletonProps {
    currentView: ViewKey;
}

export const WorkItemRowSkeleton: React.FC<WorkItemRowSkeletonProps> = ({ currentView }) => {
    return (
        <TableRow sx={{ borderLeft: '4px solid transparent' }}>
            <TableCell padding="checkbox">
                <Skeleton variant="circular" width={20} height={20} />
            </TableCell>
            <TableCell sx={{ py: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="rounded" width={80} height={16} sx={{ borderRadius: 99 }} />
                    <Skeleton variant="text" width="40%" height={14} />
                </Box>
            </TableCell>

            {currentView === 'all' && (
                <>
                    <TableCell><Skeleton variant="text" width={50} /></TableCell>
                    <TableCell><Skeleton variant="rounded" width={40} height={18} /></TableCell>
                    <TableCell><Skeleton variant="text" width={50} /></TableCell>
                </>
            )}

            {currentView === 'applications' && (
                <>
                    <TableCell>
                        <Skeleton variant="rounded" width={60} height={20} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width={40} height={12} />
                    </TableCell>
                    <TableCell><Skeleton variant="text" width={80} /></TableCell>
                </>
            )}

            {currentView === 'tasks' && (
                <>
                    <TableCell><Skeleton variant="rounded" width={40} height={18} /></TableCell>
                    <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <Skeleton variant="rounded" width={30} height={16} />
                            <Skeleton variant="rounded" width={30} height={16} />
                        </Box>
                    </TableCell>
                </>
            )}

            {currentView === 'inbox' && (
                <>
                    <TableCell><Skeleton variant="text" width={50} /></TableCell>
                    <TableCell><Skeleton variant="rounded" width={40} height={16} /></TableCell>
                </>
            )}

            <TableCell>
                <Skeleton variant="rounded" width={60} height={18} />
            </TableCell>
            <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="circular" width={24} height={24} />
                </Box>
            </TableCell>
        </TableRow>
    );
};

export const WorkItemsTableSkeleton: React.FC<WorkItemRowSkeletonProps> = ({ currentView }) => {
    return (
        <>
            {[...Array(6)].map((_, i) => (
                <WorkItemRowSkeleton key={i} currentView={currentView} />
            ))}
        </>
    );
};
